export interface MockTranscript {
  id: string;
  title: string;
  created_at: string;
  duration_sec: number;
  status: 'completed' | 'processing' | 'failed';
  transcript_text: string;
  type: 'voice' | 'lecture' | 'meeting';
  ai_outputs: {
    short_summary: string;
    detailed_summary: string;
    tasks: string[];
    english_translation: string;
    chapters: Array<{ title: string; content: string; timestamp_sec: number }>;
  };
}

export const mockTranscripts: MockTranscript[] = [
  {
    id: 'tr-demo-001',
    title: 'جلسه تیم محصول',
    created_at: new Date(Date.now() - 86400000).toISOString(),
    duration_sec: 1860,
    status: 'completed',
    type: 'meeting',
    transcript_text: `سلام بر همه. امروز جلسه هفتگی تیم محصول رو داریم. اول از همه بحث roadmap رو داریم.

خب، در مورد sprint بعدی، چند تا feature priority داریم:

۱. قابلیت جستجوی پیشرفته در داشبورد
۲. بهبود performance در صفحه اصلی
۳. اضافه کردن فیلترهای جدید برای گزارش‌گیری

واقعاً این ماه فشار کار زیاده ولی تیم داره خوب کار می‌کنه.

نکته مهم بعدی در مورد بازخورد کاربرهاست. کاربرها از قابلیت جستجوی جدید راضی هستند ولی می‌گن کند کار می‌کنه.

باید حتماً این issue رو در اولویت قرار بدیم.

خب بریم سراغ بحث بعدی. در مورد timeline تحویل featureهای sprint بعدی.

تاریخ تحویل featureهای اول و دوم ۱۵ ماه هست. feature سوم هم ۲۰ ماه.

تصمیم نهایی: feature جستجوی پیشرفته و بهبود performance در sprint بعدی انجام بشه. feature فیلترها به sprint بعد از اون موکول بشه.

اکشن‌آیتم‌ها:
- علی: پیگیری issue سرعت جستجو - deadline: ۳ روز
- مریم: آماده کردن مستندات featureهای جدید - deadline: ۱ هفته
- حسین: هماهنگی با تیم backend برای APIهای جدید - deadline: ۵ روز`,
    ai_outputs: {
      short_summary: 'جلسه تیم محصول با تمرکز بر اولویت‌بندی sprint بعدی و بررسی بازخورد کاربران. سه feature اصلی شامل جستجوی پیشرفته، بهبود performance و فیلترهای جدید مصوب شد.',
      detailed_summary: 'در این جلسه هفتگی تیم محصول، در مورد سه موضوع اصلی بحث شد:\n\n۱. اولویت‌بندی sprint بعدی: سه feature اصلی شامل جستجوی پیشرفته، بهبود performance صفحه اصلی و فیلترهای جدید برای گزارش‌گیری تعیین شدند.\n\n۲. بازخورد کاربران: کاربران از قابلیت جستجوی جدید رضایت دارند اما عملکرد کند آن را گزارش کرده‌اند. این issue به عنوان اولویت بالا تعیین شد.\n\n۳. timeline تحویل: featureهای اول و دوم تا ۱۵ ماه و feature سوم تا ۲۰ ماه باید تحویل داده شوند.\n\nتصمیم نهایی: جستجوی پیشرفته و بهبود performance در sprint بعدی اجرا شود. فیلترهای جدید به sprint پس از آن موکول شد.',
      tasks: [
        'علی: پیگیری issue سرعت جستجو - deadline: ۳ روز',
        'مریم: آماده کردن مستندات featureهای جدید - deadline: ۱ هفته',
        'حسین: هماهنگی با تیم backend برای APIهای جدید - deadline: ۵ روز',
        'بررسی issue سرعت جستجو و رفع مشکل performance',
        'مستندسازی featureهای جدید برای sprint بعدی',
      ],
      english_translation: 'Hello everyone. Today we have our weekly product team meeting. First, let\'s discuss the roadmap...',
      chapters: [
        { title: 'معرفی و دستور جلسه', content: 'سلام بر همه. امروز جلسه هفتگی تیم محصول رو داریم. اول از همه بحث roadmap رو داریم.', timestamp_sec: 0 },
        { title: 'اولویت‌های sprint بعدی', content: 'خب، در مورد sprint بعدی، چند تا feature priority داریم...', timestamp_sec: 120 },
        { title: 'بازخورد کاربران', content: 'نکته مهم بعدی در مورد بازخورد کاربرهاست...', timestamp_sec: 420 },
        { title: 'زمان‌بندی تحویل', content: 'خب بریم سراغ بحث بعدی. در مورد timeline تحویل featureهای sprint بعدی.', timestamp_sec: 780 },
        { title: 'تصمیمات و اقدامات', content: 'تصمیم نهایی: feature جستجوی پیشرفته و بهبود performance در sprint بعدی انجام بشه.', timestamp_sec: 1200 },
      ],
    },
  },
  {
    id: 'tr-demo-002',
    title: 'درس معماری نرم‌افزار - جلسه ۷',
    created_at: new Date(Date.now() - 172800000).toISOString(),
    duration_sec: 5400,
    status: 'completed',
    type: 'lecture',
    transcript_text: `امروز می‌خوایم در مورد معماری میکروسرویس‌ها صحبت کنیم.

اول از همه، بیاین ببینیم چرا به میکروسرویس نیاز داریم. توی معماری یکپارچه یا monolith، همه چیز توی یک executable هست. این برای تیم‌های کوچیک خوبه اما وقتی تیم بزرگ می‌شه، مشکلاتی ایجاد می‌کنه.

مشکلات معماری یکپارچه:
۱. deploy شدن کل سیستم برای یه تغییر کوچیک
۲. scaling دشوار
۳. وابستگی‌های تنگاتنگ بین ماژول‌ها

حالا میکروسرویس چیه؟ هر سرویس یک قابلیت مجزای کسب و کار رو پیاده می‌کنه. هر سرویس مستقلاً deploy می‌شه.

مهم‌ترین ویژگی‌های میکروسرویس:
۱. autonomy - هر سرویس مستقل
۲. decentralized data management
۳. resilience - خطا در یک سرویس بقیه رو تحت تأثیر قرار نمی‌ده
۴. scalability مستقل

اما چالش‌هایی هم داره:
۱. پیچیدگی شبکه
۲. داده‌های توزیع شده
۳. testing پیچیده‌تر
۴. نیاز به DevOps قوی`,
    ai_outputs: {
      short_summary: 'جلسه هفتم درس معماری نرم‌افزار با موضوع میکروسرویس‌ها. مفاهیم، مزایا و چالش‌های معماری میکروسرویس در مقابل معماری یکپارچه بررسی شد.',
      detailed_summary: 'در این جلسه آموزشی، معماری میکروسرویس‌ها به صورت جامع بررسی شد:\n\n۱. مقایسه معماری یکپارچه و میکروسرویس: معماری یکپارچه برای تیم‌های کوچک مناسب است اما با بزرگ شدن تیم، مشکلات deploy، scaling و وابستگی‌های تنگاتنگ ایجاد می‌کند.\n\n۲. تعریف میکروسرویس: هر سرویس یک قابلیت مجزای کسب و کار را پیاده می‌کند و مستقل deploy می‌شود.\n\n۳. ویژگی‌های اصلی: autonomy، مدیریت داده غیرمتمرکز، مقاوم بودن در برابر خطا (resilience) و scalability مستقل.\n\n۴. چالش‌ها: پیچیدگی شبکه، داده‌های توزیع شده، testing پیچیده و نیاز به DevOps قوی.',
      tasks: [
        'مطالعه مقاله Martin Fowler در مورد میکروسرویس‌ها',
        'پیاده‌سازی یک نمونه ساده از میکروسرویس با Docker',
        'بررسی ابزارهای service mesh مانند Istio',
        'تمرین پیاده‌سازی API Gateway',
        'آماده‌سازی برای آزمون میان‌ترم',
      ],
      english_translation: 'Today we want to talk about microservice architecture. First, let\'s see why we need microservices...',
      chapters: [
        { title: 'مقدمه و معماری یکپارچه', content: 'امروز می‌خوایم در مورد معماری میکروسرویس‌ها صحبت کنیم.', timestamp_sec: 0 },
        { title: 'مشکلات معماری یکپارچه', content: 'مشکلات معماری یکپارچه: deploy شدن کل سیستم برای یه تغییر کوچیک...', timestamp_sec: 180 },
        { title: 'تعریف میکروسرویس', content: 'حالا میکروسرویس چیه؟ هر سرویس یک قابلیت مجزای کسب و کار رو پیاده می‌کنه.', timestamp_sec: 900 },
        { title: 'ویژگی‌های میکروسرویس', content: 'مهم‌ترین ویژگی‌های میکروسرویس: autonomy, decentralized data management...', timestamp_sec: 1800 },
        { title: 'چالش‌ها', content: 'اما چالش‌هایی هم داره: پیچیدگی شبکه، داده‌های توزیع شده...', timestamp_sec: 3000 },
      ],
    },
  },
  {
    id: 'tr-demo-003',
    title: 'ایده‌های جدید برای استارتاپ',
    created_at: new Date(Date.now() - 259200000).toISOString(),
    duration_sec: 420,
    status: 'completed',
    type: 'voice',
    transcript_text: `سلام. یه سری ایده به ذهنم رسیده که می‌خوام بنویسم.

اولین ایده: یه اپلیکیشن برای مدیریت عادت‌های روزانه. خیلی از مردم می‌خوان عادت‌های خوب داشته باشن ولی نمی‌تونن پایبند باشن.

دومین ایده: یه سرویس اشتراک‌گذاری دانش برای تیم‌های remote. توی دوران دورکاری، انتقال دانش خیلی سخت شده.

سومین ایده: یه پلتفرم برای کوچینگ شغلی با هوش مصنوعی. خیلیا توی مسیر شغلیشون سردرگمن.

راستی، برای ایده اول باید حتماً gamification اضافه کنم. بدون gamification کار نمی‌کنه.

برای ایده دوم، مهم‌ترین چیز جستجوی خوب و دسته‌بندی مناسبه.

ایده سوم نیاز به یه مدل زبانی خوب داره.

فعلاً همینا. بعداً بیشتر فکر می‌کنم.`,
    ai_outputs: {
      short_summary: 'سه ایده استارتاپی: اپلیکیشن مدیریت عادت‌های روزانه، سرویس اشتراک‌گذاری دانش برای تیم‌های remote، و پلتفرم کوچینگ شغلی با هوش مصنوعی.',
      detailed_summary: 'سه ایده استارتاپی ثبت شد:\n\n۱. اپلیکیشن مدیریت عادت‌های روزانه با قابلیت gamification. هدف کمک به افراد برای ایجاد و حفظ عادت‌های خوب.\n\n۲. سرویس اشتراک‌گذاری دانش برای تیم‌های remote. راهکاری برای انتقال دانش در دوران دورکاری با تأکید بر جستجوی خوب و دسته‌بندی.\n\n۳. پلتفرم کوچینگ شغلی با هوش مصنوعی. کمک به افراد سردرگم در مسیر شغلی با استفاده از مدل‌های زبانی.\n\nنکات کلیدی: ایده اول نیازمند gamification، ایده دوم نیازمند جستجوی قوی و دسته‌بندی، ایده سوم نیازمند مدل زبانی پیشرفته.',
      tasks: [
        'تحقیق در مورد رقبای اپلیکیشن مدیریت عادت',
        'مصاحبه با ۱۰ نفر برای اعتبارسنجی ایده اشتراک‌گذاری دانش',
        'بررسی APIهای مدل‌های زبانی برای ایده کوچینگ شغلی',
        'طراحی MVP برای ایده اول',
        'تحلیل بازار برای هر سه ایده',
      ],
      english_translation: 'Hi. I have some ideas that I want to write down. First idea: a daily habit management app...',
      chapters: [
        { title: 'ایده اول: مدیریت عادت', content: 'اولین ایده: یه اپلیکیشن برای مدیریت عادت‌های روزانه.', timestamp_sec: 0 },
        { title: 'ایده دوم: اشتراک دانش', content: 'دومین ایده: یه سرویس اشتراک‌گذاری دانش برای تیم‌های remote.', timestamp_sec: 90 },
        { title: 'ایده سوم: کوچینگ شغلی', content: 'سومین ایده: یه پلتفرم برای کوچینگ شغلی با هوش مصنوعی.', timestamp_sec: 180 },
        { title: 'ملاحظات هر ایده', content: 'راستی، برای ایده اول باید حتماً gamification اضافه کنم.', timestamp_sec: 270 },
      ],
    },
  },
  {
    id: 'tr-demo-004',
    title: 'مرور کتاب Deep Work',
    created_at: new Date(Date.now() - 345600000).toISOString(),
    duration_sec: 900,
    status: 'completed',
    type: 'voice',
    transcript_text: `می‌خوام خلاصه کتاب Deep Work از Cal Newport رو مرور کنم.

نکته اصلی کتاب اینه که توی دنیای پر از حواس‌پرتی، توانایی کار عمیق یه مزیت رقابتی بزرگه.

Newport می‌گه کار عمیق یعنی فعالیت‌های حرفه‌ای که توی مرز توانایی‌های شناختی انجام می‌شه و نتیجه قابل توجهی داره.

چهار فلسفه برای کار عمیق:
۱. monastic - مثل راهبان، کاملاً گوشه‌گیر
۲. bimodal - دوره‌های طولانی کار عمیق با وقفه
۳. rhythmic - هر روز یه زمان مشخص
۴. journalist - هر وقت فرصت شد

نکات عملی کتاب:
- minimize shallow work
- برنامه‌ریزی دقیق هر دقیقه از روز
- embrace boredom
- drain the shallows

به‌نظرم rhythmic approach برای شروع بهتره.`,
    ai_outputs: {
      short_summary: 'خلاصه کتاب Deep Work از Cal Newport: اهمیت کار عمیق در دنیای پر از حواس‌پرتی، چهار فلسفه کار عمیق، و نکات عملی برای پیاده‌سازی.',
      detailed_summary: 'خلاصه کتاب Deep Work از Cal Newport:\n\nتعریف کار عمیق: فعالیت‌های حرفه‌ای در مرز توانایی‌های شناختی که نتیجه قابل توجهی دارند.\n\nچهار فلسفه کار عمیق:\n۱. Monastic: گوشه‌گیری کامل از دنیای بیرون\n۲. Bimodal: دوره‌های طولانی کار عمیق با وقفه‌های زمانی\n۳. Rhythmic: زمان مشخص روزانه برای کار عمیق\n۴. Journalist: کار عمیق در فرصت‌های پیش‌آمده\n\nنکات عملی:\n- کم کردن کارهای سطحی (shallow work)\n- برنامه‌ریزی دقیق هر دقیقه از روز\n- پذیرش کسالت و مقاومت در برابر حواس‌پرتی\n- خشک کردن بخش‌های کم‌اهمیت\n\nتوصیه: شروع با رویکرد rhythmic (روزانه در زمان مشخص)',
      tasks: [
        'اجرای رویکرد rhythmic: ۲ ساعت کار عمیق روزانه',
        'حذف نوتیفیکیشن‌های غیرضروری',
        'برنامه‌ریزی دقیق روزانه با بازه‌های ۳۰ دقیقه',
        'امتحان رویکرد monastic در تعطیلات آخر هفته',
        'مطالعه کتاب‌های مرتبط: Atomic Habits',
      ],
      english_translation: 'I want to review the summary of the book Deep Work by Cal Newport...',
      chapters: [
        { title: 'مقدمه', content: 'می‌خوام خلاصه کتاب Deep Work از Cal Newport رو مرور کنم.', timestamp_sec: 0 },
        { title: 'تعریف کار عمیق', content: 'نکته اصلی کتاب اینه که توی دنیای پر از حواس‌پرتی، توانایی کار عمیق یه مزیت رقابتی بزرگه.', timestamp_sec: 60 },
        { title: 'چهار فلسفه کار عمیق', content: 'چهار فلسفه برای کار عمیق: monastic, bimodal, rhythmic, journalist', timestamp_sec: 240 },
        { title: 'نکات عملی و جمع‌بندی', content: 'نکات عملی کتاب: minimize shallow work, برنامه‌ریزی دقیق...', timestamp_sec: 540 },
      ],
    },
  },
  {
    id: 'tr-demo-005',
    title: 'گفتگوی فروش با مشتری',
    created_at: new Date(Date.now() - 432000000).toISOString(),
    duration_sec: 360,
    status: 'completed',
    type: 'meeting',
    transcript_text: `سلام. وقت بخیر. ممنون از وقتی که گذاشتید.

خب، ما در مورد سرویس رونویسی هوشمند صحبت می‌کردیم. بگذارید توضیح بدم.

سرویس ما می‌تونه فایل‌های صوتی شما رو به متن تبدیل کنه و خلاصه‌سازی هوشمند انجام بده.

مهم‌ترین ویژگی‌ها:
۱. پشتیبانی از زبان فارسی
۲. دقت بالا در تشخیص کلمات
۳. سرعت پردازش بالا
۴. امکان جستجو در متن‌ها

هزینه‌ها خیلی مقرون‌به‌صرفه است. برای تیم‌های ۵ تا ۱۰ نفره، پلن business با ۵۰۰ هزار تومان در ماه شروع می‌شه.

برای تیم شما با ۲۰ نفر، پلن enterprise رو پیشنهاد می‌دم.

مزیت رقابتی ما نسبت به بقیه، دقت در زبان فارسی و سرعت بالاس.

چی فکر می‌کنید؟`,
    ai_outputs: {
      short_summary: 'گفتگوی فروش با مشتری درباره سرویس رونویسی هوشمند. ویژگی‌ها، قیمت‌گذاری و مزیت رقابتی در زبان فارسی توضیح داده شد.',
      detailed_summary: 'جلسه فروش با مشتری بالقوه:\n\nمحصول: سرویس رونویسی هوشمند صوتی به متن\n\nویژگی‌های کلیدی:\n- پشتیبانی از زبان فارسی\n- دقت بالا در تشخیص کلمات\n- سرعت پردازش بالا\n- قابلیت جستجو در متن‌ها\n\nقیمت‌گذاری:\n- پلن business (۵-۱۰ نفر): ۵۰۰ هزار تومان ماهانه\n- پیشنهاد پلن enterprise برای تیم ۲۰ نفره\n\nمزیت رقابتی: دقت بالا در زبان فارسی و سرعت پردازش',
      tasks: [
        'ارسال پیش‌فاکتور برای مشتری',
        'آماده‌سازی دموی اختصاصی برای تیم مشتری',
        'پیگیری نتیجه جلسه تا ۳ روز آینده',
        'تهیه قرارداد پلن enterprise',
      ],
      english_translation: 'Hello. Thank you for your time. We were discussing our intelligent transcription service...',
      chapters: [
        { title: 'معرفی سرویس', content: 'خب، ما در مورد سرویس رونویسی هوشمند صحبت می‌کردیم.', timestamp_sec: 0 },
        { title: 'ویژگی‌ها و مزایا', content: 'مهم‌ترین ویژگی‌ها: پشتیبانی از زبان فارسی...', timestamp_sec: 60 },
        { title: 'قیمت‌گذاری', content: 'هزینه‌ها خیلی مقرون‌به‌صرفه است.', timestamp_sec: 180 },
        { title: 'جمع‌بندی', content: 'مزیت رقابتی ما نسبت به بقیه، دقت در زبان فارسی و سرعت بالاس.', timestamp_sec: 280 },
      ],
    },
  },
  {
    id: 'tr-demo-006',
    title: 'ضبط تصادفی جلسه',
    created_at: new Date(Date.now() - 604800000).toISOString(),
    duration_sec: 120,
    status: 'processing',
    type: 'voice',
    transcript_text: '',
    ai_outputs: {
      short_summary: '',
      detailed_summary: '',
      tasks: [],
      english_translation: '',
      chapters: [],
    },
  },
  {
    id: 'tr-demo-007',
    title: 'مصاحبه استخدامی',
    created_at: new Date(Date.now() - 1209600000).toISOString(),
    duration_sec: 2700,
    status: 'completed',
    type: 'meeting',
    transcript_text: `خوش آمدید به مصاحبه. لطفاً خودتون رو معرفی کنید.

من ۵ سال سابقه کار به عنوان توسعه‌دهنده后端 دارم. بیشتر با Python و Django کار کردم.

چه چالش‌هایی توی کار قبلی داشتید؟

یه پروژه بود که باید یه سیستم پرداخت مقیاس‌پذیر طراحی می‌کردیم. از معماری event-driven استفاده کردیم با RabbitMQ.

خیلی جالبه. چه رویکردی برای testing داشتید؟

ما از TDD استفاده می‌کردیم. تست‌های unit با pytest و integration test با Docker.

عالیه. سوال بعدی: با microservices کار کردید؟

بله. توی پروژه قبلی تیمی ۱۵ نفره بودیم و معماری microservice داشتیم. هر سرویس با Docker containerized شده بود.

خیلی ممنون. با مسئول فنی هماهنگ می‌کنم جلسه بعدی رو.`,
    ai_outputs: {
      short_summary: 'مصاحبه استخدامی با توسعه‌دهنده后端 با ۵ سال سابقه. تجربه کار با Python/Django، معماری microservice و TDD.',
      detailed_summary: 'مصاحبه استخدامی:\n\nداوطلب: توسعه‌دهنده后端 با ۵ سال سابقه\n\nتخصص‌ها:\n- Python, Django\n- معماری event-driven با RabbitMQ\n- معماری microservice با Docker\n- TDD و تست‌نویسی با pytest\n\nتجربه قبلی: تیم ۱۵ نفره با معماری microservice\n\nنتیجه: هماهنگی جلسه بعدی با مسئول فنی',
      tasks: [
        'هماهنگی جلسه بعدی با مسئول فنی',
        'بررسی نمونه کدهای داوطلب',
        'دریافت رفرنس از کارفرمای قبلی',
        'بررسی تسک معماری برای داوطلب',
      ],
      english_translation: 'Welcome to the interview. Please introduce yourself...',
      chapters: [
        { title: 'معرفی داوطلب', content: 'خوش آمدید به مصاحبه. لطفاً خودتون رو معرفی کنید.', timestamp_sec: 0 },
        { title: 'تجربیات و چالش‌ها', content: 'یه پروژه بود که باید یه سیستم پرداخت مقیاس‌پذیر طراحی می‌کردیم.', timestamp_sec: 300 },
        { title: 'رویکرد فنی', content: 'ما از TDD استفاده می‌کردیم.', timestamp_sec: 900 },
        { title: 'تجربه microservice', content: 'توی پروژه قبلی تیمی ۱۵ نفره بودیم و معماری microservice داشتیم.', timestamp_sec: 1500 },
        { title: 'جمع‌بندی', content: 'خیلی ممنون. با مسئول فنی هماهنگ می‌کنم جلسه بعدی رو.', timestamp_sec: 2400 },
      ],
    },
  },
];

export const getTranscriptById = (id: string): MockTranscript | undefined => {
  return mockTranscripts.find(t => t.id === id);
};

export const getStatusLabel = (status: string): string => {
  const labels: Record<string, string> = {
    completed: 'تکمیل شده',
    processing: 'در حال پردازش',
    failed: 'ناموفق',
  };
  return labels[status] || status;
};

export const getStatusColor = (status: string): string => {
  const colors: Record<string, string> = {
    completed: '#2e7d32',
    processing: '#f57c00',
    failed: '#c62828',
  };
  return colors[status] || '#666';
};

export const getStatusBgColor = (status: string): string => {
  const colors: Record<string, string> = {
    completed: '#e8f5e9',
    processing: '#fff3e0',
    failed: '#ffebee',
  };
  return colors[status] || '#f5f5f5';
};

export const getTypeLabel = (type: string): string => {
  const labels: Record<string, string> = {
    voice: '🎙️ یادداشت صوتی',
    lecture: '📚 درس',
    meeting: '🤝 جلسه',
  };
  return labels[type] || type;
};

export const formatDuration = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  if (mins >= 60) {
    const hours = Math.floor(mins / 60);
    const remainingMins = mins % 60;
    return `${hours}:${remainingMins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

export const mockUserData = {
  user_id: 'demo-user',
  bale_user_id: '123456789',
  username: 'demo_user',
  first_name: 'کاربر',
  last_name: 'آزمایشی',
};

export const mockBalanceData = {
  balance: {
    total_credits: 5000,
    available_credits: 4200,
    reserved_credits: 800,
    equivalent_minutes: 350,
  },
  current_plan: null,
  usage_summary: null,
};
